module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Safe-06f8afd1ce71f129070650a50a71dec1.svg";